import React from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';

const ModalBackdrop = styled.div`
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex; justify-content: center; align-items: center; z-index: 1050;
`;

const ModalContent = styled.div`
  background: white; padding: 2rem; border-radius: 8px;
  width: 90%; max-width: 700px; position: relative;
  max-height: 90vh;
  overflow-y: auto;
`;

const CloseButton = styled.button`
  position: absolute; top: 15px; right: 15px;
  background: none; border: none; font-size: 1.5rem; cursor: pointer;
`;

const Title = styled.h2`
  margin-top: 0; margin-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
`;

const AnswerGrid = styled.div`
  display: grid;
  gap: 1.5rem;
`;

const AnswerItem = styled.div`
  text-align: left;
`;

const QuestionLabel = styled.p`
  font-weight: bold;
  color: #333;
  margin: 0 0 0.5rem 0;
`;

const AnswerValue = styled.div`
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  color: #555;
  white-space: pre-wrap; /* Preserve formatting for multi-line answers */
`;

const FilesSection = styled.div`
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
`;

const FilesSectionTitle = styled.h3`
  margin: 0 0 1rem;
  font-size: 1.05rem;
`;

const FileRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f9fa;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 0.75rem;
`;

const ViewFileButton = styled.button`
  padding: 6px 14px;
  background-color: #005eb8;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  &:hover { background-color: #004a94; }
`;

const humanizeKey = (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());

const QuestionnaireViewerModal = ({ data, onClose, onViewFile }) => {
    if (!data || (!data.answers && !data.questionnaireFiles)) return null;

    const { orderId, answers, questionnaireFiles } = data;

    // Filter out empty answers and internal properties
    const displayableAnswers = Object.entries(answers || {}).filter(([key, value]) => {
        if (!value) return false;
        if (typeof value === 'object' && Object.keys(value).length === 0) return false;
        return true;
    });

    const fileEntries = Object.entries(questionnaireFiles || {}).filter(([, file]) => file && file.filename);

    return (
        <ModalBackdrop onClick={onClose}>
            <ModalContent onClick={e => e.stopPropagation()}>
                <CloseButton onClick={onClose}><FaTimes /></CloseButton>
                <Title>Questionnaire for Order: {orderId}</Title>
                <AnswerGrid>
                    {displayableAnswers.map(([key, value]) => (
                        <AnswerItem key={key}>
                            <QuestionLabel>{humanizeKey(key)}:</QuestionLabel>
                            <AnswerValue>
                                {typeof value === 'object'
                                    ? Object.keys(value).filter(k => value[k]).join(', ')
                                    : String(value)}
                            </AnswerValue>
                        </AnswerItem>
                    ))}
                </AnswerGrid>

                {fileEntries.length > 0 && (
                    <FilesSection>
                        <FilesSectionTitle>Attached Files</FilesSectionTitle>
                        {fileEntries.map(([key, file]) => (
                            <FileRow key={key}>
                                <span>{humanizeKey(key)}: {file.originalname || 'File'}</span>
                                <ViewFileButton
                                    type="button"
                                    onClick={() => onViewFile && onViewFile({ type: 'file', url: file.url, title: humanizeKey(key), mimetype: file.mimetype })}
                                >
                                    View
                                </ViewFileButton>
                            </FileRow>
                        ))}
                    </FilesSection>
                )}
            </ModalContent>
        </ModalBackdrop>
    );
};

export default QuestionnaireViewerModal;